import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import {
  createViewEdit,
  formatAmount,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { URL_WAGES } from "../../utils/urls";

const useWages = () => {
  const tableColumns = () => [
    {
      id: "staff_type",
      header: "Staff Type",
      filter: {
        type: "text",
      },
    },
    {
      id: "district",
      header: "District",
      filter: {
        type: "text",
      },
    },
    {
      id: "commission_percentage",
      header: "Commission(%)",
      filter: {
        type: "number",
      },
    },
    {
      id: "fixed_wage",
      header: "Fixed Wage",
      filter: {
        type: "number",
      },
    },
    {
      id: "is_active",
      header: "Is Active",
      // filter: {
      //   type: "number",
      // },
    },
    {
      id: "created_at",
      header: "Created At",
      filter: {
        type: "date",
      },
    },
    {
      id: "created_by",
      header: "Created By",
      filter: {
        type: "text",
      },
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        is_active: <BooleanTags status={item?.is_active} />,
        district: item?.district,
        commission_percentage: `${item?.commission_percentage}%`,
        fixed_wage: numberFormat(item?.fixed_wage),
        created_by: `${item?.created_by?.first_name} ${item?.created_by?.last_name}`,
        created_at: formatDateTime(item?.created_at),
        actions: (
          <FormActions
            actions={[...createViewEdit(URL_WAGES, item?.id, true)]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Wage Details",
          fields: {
            id: item?.id,
            is_active: item?.is_active,
            district: item?.district,
            commission_percentage: item?.commission_percentage,
            fixed_wage: formatAmount(item?.fixed_wage),
            created_by: `${item?.created_by?.first_name} ${item?.created_by?.last_name}`,
            created_at: formatDateTime(item?.created_at),
          },
        },
      ],
    };
  };

  const formRoute = `${URL_WAGES}/create`;
  const activityFilter = "wage_configuration";

  return {
    tableColumns,
    tableData,
    activityFilter,
    formRoute,
    viewData,
  };
};

export default useWages;
